import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSettings } from '../contexts/SettingsContext';

const MediaPlayer = ({ file, className }) => {
    const { mediaVolume, setMediaVolume } = useSettings();
    const [isPlaying, setIsPlaying] = useState(false);
    const mediaRef = useRef(null);
    const isVideo = file.type.startsWith('video/');
    const Media = isVideo ? 'video' : 'audio';
    const isMov = isVideo && (file.type === 'video/quicktime' || file.url.toLowerCase().endsWith('.mov'));

    const syncMediaVolume = useCallback((element) => {
        mediaRef.current = element;
        if (element && element.volume !== mediaVolume) element.volume = mediaVolume;
    }, [mediaVolume]);

    useEffect(() => {
        const media = mediaRef.current;
        return () => {
            if (media && !media.paused) media.pause();
        };
    }, []);

    const handlePlay = (event) => {
        const current = event.currentTarget;
        document.querySelectorAll('[data-fileview-player]').forEach((media) => {
            if (media !== current && !media.paused) media.pause();
        });
        setIsPlaying(true);
    };

    return (
        <div className="relative w-full">
            <Media
                controls
                autoPlay
                data-fileview-player
                aria-label={file.name}
                ref={syncMediaVolume}
                onVolumeChange={(event) => setMediaVolume(event.currentTarget.volume)}
                onPlay={handlePlay}
                onPause={() => setIsPlaying(false)}
                onEnded={() => setIsPlaying(false)}
                className={className}
            >
                <source src={file.url} type={file.type} />
                {isMov && <source src={file.url} type="video/mp4" />}
            </Media>
            {isPlaying && (
                <span role="status" className={'pointer-events-none absolute rounded-full bg-emerald-600 px-2 py-1 text-xs font-semibold text-white shadow ' + (isVideo ? 'top-3 left-3' : '-top-8 right-0')}>
                    再生中
                </span>
            )}
        </div>
    );
};

export default MediaPlayer;
